<template>
    <div class="wrapper">
        <article>
            <header>
                <h2>{{ $t('contact.title') }}</h2>
            </header>
            <div class="content">
                <i18n-t keypath="contact.text" tag="p" scope="global">
                    <template #voidzero>
                        <a href="https://www.void-zero.nl" target="_blank" rel="noopener">
                            Void Zero
                        </a>
                    </template>
                    <template #br>
                        <br />
                    </template>
                    <template #company>
                        <strong>{{ $t('general.company') }}</strong>
                    </template>
                    <template #email>
                        <a :href="`mailto:${$t('general.email')}`">{{ $t('general.email') }}</a>
                    </template>
                </i18n-t>
            </div>
        </article>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
    @use '@/assets/mixins/containers.scss' as *;
    @use '@/assets/mixins/vertical-rhythm.scss' as *;

    .wrapper {
        height: 100%;
        overflow: scroll;
    }

    article {
        margin: 0 auto;

        @include content(90%);

        @include breakpoint(medium) {
            @include content(750px);
        }

        h1 {
            font-size: 1.94em;
            line-height: 1.68em;
            margin-bottom: 0.355em;
            padding-top: 0.484em;
        }

        :deep(h2) {
            font-size: 1.56em;
            line-height: 1.04em;
            margin-bottom: 0;
            padding-top: 0.2em;
        }

        h3 {
            font-size: 1.25em;
            line-height: 1.3em;
            margin-bottom: 1em;
            padding-top: 0.3em;
        }

        h4 {
            font-size: 1em;
            line-height: 1.63em;
            margin-bottom: 1.13em;
            padding-top: 0.5em;
        }

        :deep(p) {
            font-size: 1em;
            line-height: 1.63em;
            margin-bottom: 1.13em;
            padding-top: 0.5em;
        }

        :deep(strong) {
            color: hsl(var(--primary-500));
        }
    }
</style>
